import {createAction} from '@reduxjs/toolkit';

export const setAreaCoverage = createAction('SET_AREA_COVERAGE');
